import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M23.25 12.75V6H16.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m23.25 6-7.939 7.939a1.5 1.5 0 0 1-2.122 0l-3.128-3.128a1.5 1.5 0 0 0-2.122 0L.75 18"
    }, null, -1)
  ]));
}
const moneyGraphArrowIncrease = { render };
export {
  moneyGraphArrowIncrease as default,
  render
};
//# sourceMappingURL=money-graph-arrow-increase.svg.js.map
